import { $, $$, sendForm } from './lib.js';

/**
 * Lesson generator: submits via fetch so we can show staged progress, keeps
 * every field value on error, and falls back to a normal POST without JS.
 */
export function initGenerator() {
  const form = $('[data-generate-form]');
  if (!form) return;

  $$('[data-topic]').forEach((chip) =>
    chip.addEventListener('click', () => {
      const input = $('#topic', form);
      input.value = chip.dataset.topic;
      input.focus();
    }),
  );

  const progress = $('#generate-progress');
  const errorBox = $('#generate-error');
  const submit = $('[data-generate-submit]', form);
  let timers = [];

  const showSteps = () => {
    const steps = $$('[data-step]', progress);
    steps.forEach((s) => s.classList.remove('text-ink', 'font-medium'));
    const mark = (i) => {
      steps.forEach((s, j) => {
        const dot = s.querySelector('.dot');
        dot.className = `dot ${j < i ? 'bg-emerald-600' : j === i ? 'bg-ink animate-pulse' : 'bg-silver'}`;
        s.classList.toggle('text-ink', j <= i);
        s.classList.toggle('font-medium', j === i);
      });
    };
    mark(0);
    [6000, 15000, 26000].forEach((ms, i) => timers.push(setTimeout(() => mark(i + 1), ms)));
  };

  form.addEventListener('submit', async (event) => {
    if (!$('#topic', form).value.trim()) {
      event.preventDefault();
      showError('Enter a topic or pick one of the suggestions.');
      $('#topic', form).focus();
      return;
    }
    event.preventDefault();
    errorBox.hidden = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    form.classList.add('opacity-50', 'pointer-events-none');
    progress.hidden = false;
    progress.scrollIntoView({ behavior: 'smooth', block: 'center' });
    showSteps();

    const result = await sendForm(form);
    timers.forEach(clearTimeout);
    timers = [];

    if (result.ok && result.data.redirect) {
      $('[data-progress-title]', progress).textContent = 'Lesson ready — opening the editor…';
      window.location.href = result.data.redirect;
      return;
    }

    progress.hidden = true;
    form.classList.remove('opacity-50', 'pointer-events-none');
    form.removeAttribute('aria-busy');
    submit.disabled = false;
    showError(result.data.error || 'Generation failed. Please try again.', result.data.errors);
  });

  function showError(message, fieldErrors = {}) {
    errorBox.hidden = false;
    $('[data-error-text]', errorBox).textContent = message;
    $$('.field-error[data-js]', form).forEach((el) => el.remove());
    Object.entries(fieldErrors || {}).forEach(([field, text]) => {
      const input = form.querySelector(`[name="${field}"]`);
      if (!input) return;
      const p = document.createElement('p');
      p.className = 'field-error';
      p.dataset.js = '';
      p.textContent = text;
      (input.closest('fieldset') || input.parentElement).append(p);
    });
    errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
